import { useContext } from 'react';
import { AuthContext } from '@/lib/context/AuthContextType';

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};
